// checkIfEndorsementsAreComplete — for each checked endorsement, verifies the
// corresponding endorsement data in Redux is complete (i.e., all required fields
// have been filled). Example: if workplaceViolenceCoverage is checked, ensures
// endorsements.workplaceViolenceCoverage.limits has a value.
import {
  selectEPLICoverageLimit,
  selectWorkplaceViolenceCoverageLimit,
  selectEquipmentBreakdownEndorsement,
  selectHiredCoverage,
  selectCyberCoverageLimit,
  selectRestaurantCoverage,
  selectAlcoholicBeverageSales,
  selectContractorToolsLimit,
  selectLimitDamagePremRented,
} from '../../../selectors/application';
import { EndorsementKey } from '../types';

export const endorsementCompleteSelectors: Record<string, (state: ReduxState) => unknown> = {
  [EndorsementKey.EpliCoverage]: selectEPLICoverageLimit,
  [EndorsementKey.WorkplaceViolenceCoverage]: selectWorkplaceViolenceCoverageLimit,
  [EndorsementKey.EquipmentBreakdownEndorsement]: selectEquipmentBreakdownEndorsement,
  [EndorsementKey.HiredAutoAndNonOwnedAuto]: selectHiredCoverage,
  [EndorsementKey.CyberCoverage]: selectCyberCoverageLimit,
  [EndorsementKey.RestaurantCoverage]: selectRestaurantCoverage,
  [EndorsementKey.LiquorLiabilityEndorsement]: selectAlcoholicBeverageSales,
  [EndorsementKey.ContractorsInstallationAndTools]: selectContractorToolsLimit,
  [EndorsementKey.LimitDamagePremRented]: selectLimitDamagePremRented,
};

const checkIfEndorsementsAreComplete = (checkedEndorsements: string[], state: ReduxState): boolean => {
  return checkedEndorsements.every((endorsementKey) => {
    const selector = endorsementCompleteSelectors[endorsementKey];
    if (!selector) return true;
    return Boolean(selector(state));
  });
};

export default checkIfEndorsementsAreComplete;
